"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Application = void 0;
// tslint:disable-next-line ordered-imports
var PIXI = require("pixi.js");
var TimelineLite_1 = require("gsap/TimelineLite");
var PubSub = require("pubsub-js");
var HowlerManager_1 = require("./Audio/HowlerManager");
var VoiceOverManager_1 = require("./Audio/VoiceOverManager");
var CopyManager_1 = require("./Copy/CopyManager");
var Data_1 = require("./Data");
var Topics = require("./Data/Topics");
var HitAreaRenderer_1 = require("./Input/HitAreaRenderer");
var KeyboardManager_1 = require("./Input/KeyboardManager");
var MouseManager_1 = require("./Input/MouseManager");
var LoadManager_1 = require("./Load/LoadManager");
var SplashScreen_1 = require("./Load/SplashScreen");
var PopupManager_1 = require("./Popup/PopupManager");
var SaveManager_1 = require("./Save/SaveManager");
var StateManager_1 = require("./State/StateManager");
var AssetUtils_1 = require("./Utils/AssetUtils");
var OrientationManager_1 = require("./Utils/OrientationManager");
var ResizeManager_1 = require("./Utils/ResizeManager");
var WebEventsManager_1 = require("./Utils/WebEventsManager");
var Application = /** @class */ (function (_super) {
    __extends(Application, _super);
    /**
     * The config passed in can be a json object, or an `AppConfig` object.
     * @param pConfig
     * @see `AppConfig` for what can be contained in the passed in config.
     * @default autoResize: true
     * @default resolution: PIXI.utils.isMobile.any === false ? 2 : (window.devicePixelRatio > 1 ? 2 : 1);
     */
    function Application(pConfig) {
        var _this = 
        // TODO Relish GM => Look into what might be added to the AppConfig class and if there is reason to cache it.
        _super.call(this, new Data_1.AppConfig(pConfig)) || this;
        // TODO:SH: Find a better alternative to having this be assigned here (rework ResourceUtils?)
        AssetUtils_1.AssetUtils.resolutionSuffix = "@" + _this.renderer.resolution + "x";
        _this._size = new PIXI.Point();
        PIXI.Ticker.shared.add(_this.update.bind(_this));
        // Prevent Typescript from culling unused imports
        PubSub.publishSync("placeholder_message", undefined);
        _this._webEventsManager = new WebEventsManager_1.WebEventsManager();
        _this._mouseManager = new MouseManager_1.MouseManager(_this.renderer.plugins.interaction);
        _this._stateManager = new StateManager_1.StateManager();
        _this._popupManager = new PopupManager_1.PopupManager();
        _this._loadManager = new LoadManager_1.LoadManager(_this.createSplashScreen());
        _this._audioManager = new HowlerManager_1.HowlerManager();
        _this._keyboardManager = new KeyboardManager_1.KeyboardManager();
        _this._resizeManager = new ResizeManager_1.ResizeManager(Application.SIZE_MIN_DEFAULT, Application.SIZE_MAX_DEFAULT);
        _this._copyManager = new CopyManager_1.CopyManager();
        _this._saveManager = new SaveManager_1.SaveManager();
        _this._orientationManager = new OrientationManager_1.OrientationManager();
        _this._voiceoverManager = new VoiceOverManager_1.VoiceOverManager();
        return _this;
    }
    Object.defineProperty(Application, "instance", {
        get: function () {
            if (Application._instance === undefined) {
                console.error("You've tried to access the instance of HLF.Application when it hasn't been set. " +
                    "Please set the _instance in your Application.");
            }
            return Application._instance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "requiredAssets", {
        /**
         * Override to specify assets that should persist between state loads.
         *
         * Note: Splash screen assets are loaded before requiredAssets
         * @override
         */
        get: function () {
            // override
            return new Array();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "state", {
        get: function () {
            return this._stateManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "audio", {
        get: function () {
            return this._audioManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "voiceover", {
        get: function () {
            return this._voiceoverManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "hitAreaRenderer", {
        get: function () {
            return this._hitAreaRenderer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "resizer", {
        get: function () {
            return this._resizeManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "copy", {
        get: function () {
            return this._copyManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "webEvents", {
        get: function () {
            return this._webEventsManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "saveManager", {
        get: function () {
            return this._saveManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "orientationManager", {
        get: function () {
            return this._orientationManager;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Initializes all managers and starts the splash screen process.
     */
    Application.prototype.init = function () {
        var _this = this;
        this.stage.addChild(this._stateManager);
        this.stage.addChild(this._popupManager);
        this.stage.addChild(this._loadManager);
        this._hitAreaRenderer = new HitAreaRenderer_1.HitAreaRenderer(this.stage);
        this.stage.addChild(this._hitAreaRenderer);
        this._audioManager.init();
        this.createAssetMap();
        this.registerStates();
        this.registerPopups();
        this.registerLoadingScreens();
        this._loadManager.startSplashProcess(this.requiredAssets, this.onLoadRequiredAssetsComplete.bind(this));
        this.onResize(0);
        // Delayed to fix incorrect iOS resizing in WKWebView. See: https://bugs.webkit.org/show_bug.cgi?id=170595
        this.onResize(0.5);
        this._webEventsManager.registerResizeCallback(function () { return _this.onResize(0.5); });
    };
    /**
     * Called once per frame. Updates the `StateManager`, `PopupManager`, `LoadManager` and `HitAreaRenderer`.
     */
    Application.prototype.update = function () {
        var deltaTime = PIXI.Ticker.shared.elapsedMS / 1000;
        this._stateManager.update(deltaTime);
        this._popupManager.update(deltaTime);
        this._loadManager.update(deltaTime);
        this._hitAreaRenderer.update(deltaTime);
    };
    /**
     * Override to return the appropriate splash screen instance to use.
     * @override
     */
    Application.prototype.createSplashScreen = function () {
        // override
        return new SplashScreen_1.SplashScreen();
    };
    /**
     * Override to setup the asset map for this application.
     * @override
     */
    Application.prototype.createAssetMap = function () {
        // override
    };
    /**
     * Override to register any and all loading screens needed for this application.
     * @override
     */
    Application.prototype.registerLoadingScreens = function () {
        // override
    };
    /**
     * Override to register any and all popups needed for this application.
     * @override
     */
    Application.prototype.registerPopups = function () {
        // override
    };
    /**
     * Override to register any and all states needed for this application.
     * @override
     */
    Application.prototype.registerStates = function () {
        // override
    };
    /**
     * Called when the application window is resized.
     * @param pDelay A delay before telling the rest of the application that a resize occured.
     * @default 0
     */
    Application.prototype.onResize = function (pDelay) {
        var _this = this;
        if (pDelay === void 0) { pDelay = 0; }
        new TimelineLite_1.TimelineLite().call(function () {
            _this._size.copyFrom(_this._resizeManager.getSize());
            var stageScale = _this._resizeManager.getStageScale();
            _this.stage.scale.set(stageScale);
            _this.renderer.resize(_this._size.x * stageScale, _this._size.y * stageScale);
            _this._stateManager.onResize(_this._size);
            _this._loadManager.onResize(_this._size);
            _this._popupManager.onResize(_this._size);
            _this._orientationManager.onResize(_this._size);
            PubSub.publishSync(Topics.KEYBOARD_REFOCUS, undefined);
            if (_this._hitAreaRenderer.active) {
                _this._hitAreaRenderer.renderHitAreas();
            }
            _this.onResizeComplete();
        }, undefined, this, pDelay);
    };
    /**
     * Called when resize is complete after the delay.
     * @override
     */
    Application.prototype.onResizeComplete = function () {
        // override
    };
    /**
     * Override to specify what should happen after all persistent assets have been loaded.
     * @override
     */
    Application.prototype.onLoadRequiredAssetsComplete = function () {
        // override
    };
    Application.SIZE_MIN_DEFAULT = new PIXI.Point(1024, 768);
    Application.SIZE_MAX_DEFAULT = new PIXI.Point(1365, 768);
    return Application;
}(PIXI.Application));
exports.Application = Application;
//# sourceMappingURL=Application.js.map